import { render, staticRenderFns } from "./Ldi.vue?vue&type=template&id=71fdf58a&lang=pug"
import script from "./Ldi.vue?vue&type=script&lang=js"
export * from "./Ldi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports